import { Component, Injector, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalService } from 'app/services/modal.service';

@Component({
    selector: 'psm-modal-container',
    template: `<div #modal></div>`
})
export class ModalContainerComponent implements OnInit {

    @ViewChild('modal', { read: ViewContainerRef }) public modalRef;

    constructor(
        private modalService: ModalService,
        private injector: Injector) {
    }
    public ngOnInit(): void {
        this.modalService.registerViewContainerRef(this.modalRef);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/modal/modal.container.component.ts